import { useRouteError } from 'react-router-dom'

export const isNotFoundError = (error: unknown) => {
  const isInvalidRoutePage = error === null // Only case when error is empty is when url is invalid
  const is404ErrorInValidRoute = error instanceof Error && 'status' in error && error.status === 404

  return isInvalidRoutePage || is404ErrorInValidRoute
}

export const useErrorMessage = () => {
  const error = useRouteError()

  if (isNotFoundError(error)) {
    return '404 - Not found'
  }

  return 'Something gone wrong'
}
